import { useParams } from 'react-router-dom';
import Order from './order';
import { useOrder } from '../../hooks/react-query/use-order';
import Error from '../shared/error';
import { APIErrorType } from '../../api';
import Loader from '../shared/loader';

function OrderContainer() {
  const { orderId } = useParams();
  const {
    isError,
    isLoading,
    data: order,
    error
  } = useOrder(orderId ? parseInt(orderId) : undefined);

  if (isError) return <Error error={error as APIErrorType} />;
  if (isLoading || !order) return <Loader />;

  return <Order order={order} />;
}

export default OrderContainer;
